/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
import Vue from 'vue';
import Suggestion from '../components/Suggestion';
import ResearchRoot from '../components/research/ResearchRoot';

require('./bootstrap');

Vue.component('suggestion', Suggestion);
Vue.component('research-root', ResearchRoot);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// eslint-disable-next-line no-unused-vars
const app = new Vue({
    el: '#app',
});


